export default {
    LaunchedMonth: {
        1: "1月上線",
        2: "2月上線",
        3: "3月上線",
        4: "4月上線",
        5: "5月上線",
        6: "6月上線",
        7: "7月上線",
        8: "8月上線",
        9: "9月上線",
        10: "10月上線",
        11: "11月上線",
        12: "12月上線",
        13: "即將上線",
    },
    menu: {
        home: "百勝首頁",
        hotGame: "熱門遊戲",
        tryPlay: "遊戲試玩",
        ourAdvantage: "我們的優勢",
        aboutUs: "關於我們",
        linkUs: "聯系我們",
        login: "登錄",
        register: "註冊",
    },
    indexPagePlay: {
        players: "在線玩家：129003",
        webTitle: "全球最頂尖的遊戲開發商",
        gameTry1: "遊戲試玩",
        gameTry2: "遊戲試玩2",
        bannerExplain: "純3D引擎打造極致3D效果，身臨其境如同現實博弈海量遊戲集成，為您量身定制，後續不斷更新",
        inGame: "進入遊戲",
        development: "開發中，敬請期待",
    },
    banner: {
        coming: "敬請期待",
        baijiale: "百家樂",
        lunpan: "歐式輪盤",
        buyu: "3D千炮捕魚王",
        zhanjinhua: "炸金花",
        niuniu: "搶莊牛牛",
        tuiTongzi: "百人推筒子",
        longhu: "龍虎鬥",
        dezhou: "德州撲克",
        jisuhua: "極速炸金花",
        shisanshui: "十三水",
        paijiu: "通比牌九",
        kingOfFishing3D: "捕魚王中王",
        shidianban: "十點半",
        sangong: "三公",
        ershiyidian: "二十壹點",
        bairenbaijiale: "百人百家樂",
        honghei: "紅黑大戰",
        niuniu4: "看牌搶莊牛牛",
        bairenniuniu: "百人牛牛",
        majiangxueliu: "麻將（血流）",
        benzAndBMW: "奔馳寶馬",
        forestParty: "森林舞會",
        majiangxuezhan: "麻將（血戰）",
        landlord: "鬥地主（不洗牌）",
        jinsaPoker: "金沙撲克",
        fanbeimajiang: "翻倍血流",
        pirateFishing: "3D海盜來了",
        mermaidFishing: "3D美人漁",
        dezhou_qz: "德州撲克（前註場）",
        errenmj: "二人麻將",
        ksznn_3d: "3D看四張牛牛",
        qznn_3d: "3D搶莊牛牛",
        ddzjs: "極速鬥地主",
        jokerNiuniu: "癩子牛牛",
        lkpy: '李逵劈魚',
        dntg: '大鬧天宮',
        birdingJoy:'捕鳥達人',
        goldenCountry: '黃金國度'
    },
    bannerSmallTitle: {
        baijiale: "BACCARAT",
        lunpan: "ROULETTE",
        buyu: "CANNON FISHING",
        zhanjinhua: "GOLDEN FLOWER",
        niuniu: "BANKER NIU NIU",
        tuiTongzi: "CIRCLE TILES",
        longhu: "DRAGON&TIGER",
        dezhou: "TEXAS HOLDEM",
        jisuhua: "SPEED FLOWER",
        shisanshui: "THIRTEEN POKER",
        // runFast: 'RUN FAST',
        paijiu: "PAI GOW",
        // doudizhu: "LANDLORDS",
        kingOfFishing3D: "KING OF FISHING",
        shidianban: "TEN POINT HALF",
        sangong: "THREE FACECARD",
        ershiyidian: "BLACKJACK",
        bairenbaijiale: "MULTI-PLAYERS BACCARAT",
        honghei: "RED & BLACK",
        niuniu4: "Banker Niu Niu （Cards Shown）",
        bairenniuniu: "MULTI-PLAYERS NIU-NIU",
        majiangxueliu: "Blood flow mahjong",
        benzAndBMW: " Benz & BMW",
        forestParty: "Forest Party",
        majiangxuezhan: "Blood station mahjong",
        landlord: "Landlords（No shuffle)",
        jinsaPoker: "JinSa Poker",
        fanbeimajiang: "DOUBLE BLOOD",
        pirateFishing: "3D PIRATE FISHING",
        mermaidFishing: "3D MERMAID FISHING",
        dezhou_qz: "TEXAS HOLDEM(ANTE)",
        errenmj: "2 persons mahjong",
        ksznn_3d: "3D FOUR CARDS SHOWN NIUNIU",
        qznn_3d: "3D BANKER NIUNIU",
        ddzjs: "SPEED LANDLORDS",
        jokerNiuniu: "JOKER NIUNIU",
        lkpy: 'FISHING KUI LEE',
        dntg: 'MONKEY KING',
        birdingJoy:'BIRDING JOY',
        goldenCountry: 'GOLDEN COUNTRY'
    },
    ourAdvantage: {
        title1: "萬兆光纖接入",
        content1: "高密度光纖連接平臺，讓用戶體驗什麽叫快如閃電",
        title2: "多層網絡保護",
        content2: "高防CDN,雲防加速，我們何止是快，我們穩如泰山",
        title3: "快捷api接入",
        content3: "我們提供簡單快捷的api接入解決方案，想怎麽接就怎麽接",
        title4: "3D遊戲引領",
        content4: "業內純3D引擎打造，產品體驗暢快，進入即是壹場身臨其境的完美遊戲盛宴",
        title5: "權威機構認證 ",
        content5: "遊戲經權威機構測試漏洞並給予專業認證，運行穩定是我們的宗旨",
        title6: "壹號全網通",
        content6: "電腦、IOS、iPad、安卓設備，無障礙的跨平臺應用，用戶放心下暢快玩",
        title7: "運維經驗豐富",
        content7: "10年運營維護經驗，獲CCIE、CCNP、CCNA認證資格",
        title8: "客服團隊專業",
        content8: "7*24小時專業客服團隊，更有資深專業工程師全天候為您提供服務",
    },
    NavTitle: {
        online: "已上線",
        qipaiKind: "棋牌类",
        electronGame: "电子类",
        MahjongKing: "麻将类",
        hunterKing: "捕猎类",
    },
    gameName: {
        online: {
            a: "百家樂",
            b: "歐式輪盤",
            c: "3D千炮捕魚王",
            d: "炸金花",
            e: "搶莊牛牛",
            f: "百人推筒子",
            g: "龍虎鬥",
            h: "德州撲克",
            i: "極速炸金花",
            j: "跑得快",
            k: "十三水",
            l: "通比牌九",
            m: "鬥地主",
            n: "3D捕魚王中王",
            u: "十點半",
            v: "三公",
            lkpy: '李逵劈魚',
			dntg: '大鬧天宮',
            birdingJoy:'捕鳥達人',
            goldenCountry: '黃金國度'
        },
        qipaiKind: {
            zhajinhua3d: "3D炸金花",
            bairen: "百人推筒子",
            niniu: "通比牛牛",
            tongbi: "通比推筒子",
            paijiu: "搶莊牌九",
            guandao: "摜蛋",
            sangong: "三公",
            jialebipuke: "加勒比撲克",
            ershiyidian: "二十一點",
            paohuzi: "跑鬍子",
            shaibao: "骰寶",
            bairenniuniu: "百人牛牛",
            sanzhangpuke: "三張撲克",
            doudizhu1: "極速鬥地主",
            doudizhu2: "鬥地主（不洗牌）",
            shidianban: "十點半",
            qiangzhuangtuitongzi: "搶莊推筒子",
            jokerNiuniu: "癩子牛牛",
            kszqznn: "看三張搶莊牛牛",
            developGame: "更多遊戲",
        },
        electronGame: {
            laohuji: "老虎機",
            senlinwuhui: "森林舞會",
            taiqiudashi: "台球大師",
            benchibaoma: "奔馳寶馬",
            shuiguopaidui: "水果派對",
            feiqinzoushou: "飛禽走獸",
            wangzhezuqiu: "王者足球",
            hangjinlunpan: "黃金輪盤",
            xingyunwu: "幸運五",
            developGame: "更多遊戲",
        },
        MahjongKing: {
            guangdongmajiang: "廣東麻將",
            zhuajimajiang: "抓雞麻將",
            dongbeimajiang: "東北麻將",
            errenmajiang: "二人麻将",
            xueliumajiang: "血流麻将",
            fanbeimajiang: "翻倍血流",
            taimajiang: "台灣麻將",
            guojimajiang: "國際麻將",
            hangzhoumajiang: "杭州麻将",
            kawufumajiang: "卡五福麻将",
            xuezhanmajiang: "血戰麻將",
            fuzhoumajiang: "福州麻将",
            zhongyongmajiang: "中庸麻将",
        },
        hunterKing: {
            buniaolueshou: "捕鳥獵手",
            xingjidazhan: "星際大戰",
            xingyunbuyu: "幸運捕魚",
            developGame: "更多遊戲",
        },
    },
    aboutUs: {
        p1: "百勝棋牌是壹家專註於棋牌遊戲市場的遊戲開發商。",
        p2: "我們致力於用最先進的3D技術打造最完美的視聽盛宴，帶給玩家身臨其境般的享受；",
        p3: "我們致力於給玩家帶來公平公正，有趣流暢的遊戲平臺；",
        p4: "我們致力於幫助商戶平臺提升產品競爭力和用戶活躍度，豐富商戶平臺的運營手段，降低其研發成本。",
        moreGameTitle: "更多遊戲，敬請期待",
        gameToggleInfo: "學習先行者，創造自我，超越無我",
    },
    linkUs: {
        title: "敬請留下您的聯系方式",
        name: "姓名",
        mail: "郵箱",
        phone: "手機",
        remark: "說明",
        btnTxt: "提交",
        captcha: "驗證碼",
        messages: {
            noName: "請提供壹個稱呼,方便客服聯系您！",
            noContact: "請提供壹個聯系方式，郵箱或者電話請填寫壹個！",
            noRemark: "請說明下您遇到的或者想了解的情況，至少10個字以上！",
            remarkLength: "說明信息的長度不夠！",
            mailError: "郵箱格式錯誤！",
            phoneError: "電話號碼格式錯誤！",
        },
    },
};


// WEBPACK FOOTER //
// ./src/lang/taiwan.js